import { useNavigate, useRoutes } from "react-router-dom";

import UnauthorizedRoutes from "./UnauthorizedRoutes";
import SuperAdminAuthorizedRoutes from "./SuperAdminAuthorizedRoutes";
import { useDispatch, useSelector } from "react-redux";
import { getLogout, getState } from "../../redux/actions/actions";
import ParentAuthorizedRoutes from "./ParentAuthorizedRoutes";
import AdminAuthorizedRoutes from "./AdminAuthorizedRoutes";
import { useEffect } from "react";
import ApproverAuthorizedRoutes from "./ApproverAuthenticationRoutes";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const authState = useSelector((state: any) => state.auth.authData);
  const user = getState(authState);

  const ROLES_ROUTES: any = {
    0: SuperAdminAuthorizedRoutes(0),
    1: AdminAuthorizedRoutes(1),
    2: ParentAuthorizedRoutes(2),
    3: ApproverAuthorizedRoutes(3),
    4: ApproverAuthorizedRoutes(4),
    undefined: UnauthorizedRoutes(user),
  };

  return useRoutes(user ? ROLES_ROUTES[Number(user?.role)] || UnauthorizedRoutes(user) : UnauthorizedRoutes(user));
}

export function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLogout());
  }, [navigate]);

  return <div>Logging out...</div>;
}
